<template>
  <footer class="bg-light d-block page-footer" role="contentinfo">
    <div class="row justify-content-center">
      <div class="col-7">
        <img src="/img/footer.png" width="100%" />

        <div>
          <span class="hidden-md-down fw-700">
            {{ version }} {{ buildDate | moment('YYYY') }} &copy; {{ appTitle }} by&nbsp;
            <a href="https://witkac.pl" class="fw-500" target="_blank">Witkac sp. z o.o.</a>
          </span>

          <a class="ml-3" href="https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/polityka-prywatnosci/">
            Polityka prywatności
          </a>

          <a class="ml-3" href="https://lublin.eu/edu/projekt/polityki-regulaminy-deklaracje/polityka-cookies/">
            Polityka cookies
          </a>

          <a class="ml-3" :href="informationLink">Klauzula informacyjna</a>

          <a class="ml-3" :href="wcagLink">Deklaracja dostępności</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

import { config } from '@/utils/config';
import { INFORMATION_LINKS, WCAG_LINKS } from '@/utils/constants';

// @vuese
// Stopka
// @group AppLayout
export default {
  name: 'Footer',
  computed: {
    copyYear() {
      return new Date().getFullYear();
    },
    ...mapState({
      version: state => state.system.packageVersion,
      appTitle: state => state.system.appTitle,
      buildDate: state => new Date(state.system.buildDate)
    }),

    informationLink() {
      return INFORMATION_LINKS[config.procedure];
    },

    wcagLink() {
      return WCAG_LINKS[config.procedure];
    }
  }
};
</script>
